module.exports = __webpack_public_path__ + "img/bg.1f4d568b.jpg";